import { InputLabelProps } from "@mui/material";

import { Label } from "./InputLabel.styles";

const InputLabel: React.FC<InputLabelProps & { as?: string }> = ({
  children,
  as,
  ...innerProps
}) => (
  <Label {...innerProps} as={as as unknown as React.ElementType<unknown>}>
    {children}
  </Label>
);

export default InputLabel;
